export const defaultConfig = {
    blockUniqueId: "Center_PasswordResetResponsiveBlock_22245",
    ValidationRule: "(^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()\=\-\_+])[0-9a-zA-Z!@#$%^&*()\=\-\_+]{8,20}$)",
    ExpiredPassword: false,
    prt: "string",
    onSuccessCallback: () => { },
    onCancelCallback: () => { },
};
//# sourceMappingURL=config.js.map